var app = angular.module("leonardo");

var TaskDeactivateDialog = function($scope, $rootScope, AccountUserService, TemplateService, TaskService,
                                    FormErrorsService, PortfolioService, PropertyService, FilterService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.template = $scope.ngDialogData.template;

  $scope.taskService = TaskService;

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.template.changeStatus({
      new_status: TemplateService.STATUS_UNPUBLISHED,
      portfolios: [],
      properties: [FilterService.getFilter('property')]
    }).then(function () {
      $rootScope.$broadcast('task-deactivate-dialog:success', $scope.task);
      $scope.closeThisDialog();
    });
  };
};

app.controller('TaskDeactivateDialog', ['$scope', '$rootScope', 'AccountUserService', 'TemplateService', 'TaskService',
  'FormErrorsService', 'PortfolioService', 'PropertyService', 'FilterService', TaskDeactivateDialog]);
